import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  materialData: [],
}

export const materialData = createSlice({
  name: 'materialData',
  initialState,
  reducers: {
    setMaterialData: (state, action) => {
      state.materialData = action.payload
    }
  },
})

export const { setMaterialData } = materialData.actions;

export default materialData.reducer;